export default "__VITE_ASSET__BMzd9kEg__"